export default __webpack_public_path__ + "static/media/brand_brou.a852510c.svg";